import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ColumnsAliasesState } from './interfaces/columns-aliases.state.interface';
import { ColumnAlias } from './interfaces/column-alias.interface';
import { COLUMNS_ALIASES_FEATURE_NAME } from './columns-aliases.actions';

export const columnsAliasesFeatureSelector = createSelector(
  createFeatureSelector<ColumnsAliasesState>(COLUMNS_ALIASES_FEATURE_NAME),
  state => state,
);

export const columnsAliases = createSelector(
  columnsAliasesFeatureSelector,
  state => state.columnsAliases,
);

export const loading = createSelector(
  columnsAliasesFeatureSelector,
  state => state.loading,
);

export const columnAliasByIdSelector = (id: string) => createSelector(
  columnsAliasesFeatureSelector,
  (state) => state.columnsAliases.find(alias => alias.id === id)?.id,
);

export const editModeByIdSelector = (id: string) => createSelector(
  columnsAliasesFeatureSelector,
  (state) => <boolean>state.columnsAliases.find(alias => alias.id === id)?.editMode,
);

export const columnsAliasesAttributes = createSelector(
  columnsAliasesFeatureSelector,
  state => state.columnsAliases.map((alias: ColumnAlias) => alias.attribute),
);

export const createModeSelector = createSelector(
  columnsAliasesFeatureSelector,
  state => state?.createMode,
);

